var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1777 25.8229C26.2374 37.8824 29.7711 34.9964 31.3494 33.8691C31.6044 33.7242 37.4459 29.9602 33.813 26.3281C25.3871 17.9016 27.0968 28.8544 19.1199 20.879C11.1447 12.9019 22.0983 14.6128 13.6725 6.18713C10.0393 2.55397 6.27492 8.39576 6.13175 8.64921C5.00277 10.2275 2.11808 13.7634 14.1777 25.8229Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicePhone);
export default __webpack_public_path__ + "static/media/device-phone.3a44525f9eb2290129f097579fc154d3.svg";
export { ForwardRef as ReactComponent };